(function () {
  'use strict';
  function evaluateCart(cart, config) {
    const subtotal = (cart.items || []).reduce((sum, item) =>
      sum + (item.vendor === config.vendor ? Number(item.final_line_price || 0) : 0), 0);
    const eligible = cart.currency === config.currency && subtotal >= config.threshold;
    const codes = [...new Set([
      ...(cart.discount_codes || []).map(d => d.code),
      ...(cart.cart_level_discount_applications || []).filter(d => d.type === 'discount_code').map(d => d.title),
      ...(cart.items || []).flatMap(i => (i.line_level_discount_allocations || [])
        .filter(d => d.discount_application?.type === 'discount_code').map(d => d.discount_application.title))
    ].filter(Boolean))];
    const hasCode = codes.some(c => c.toUpperCase() === config.code.toUpperCase());
    return { subtotal, eligible, hasCode, codes };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { evaluateCart };
  if (typeof document === 'undefined') return;
  const configElement = document.getElementById('fww-fluff-shipping-config');
  if (!configElement) return;
  // DEPENDS: the Liquid snippet supplies the code, USD threshold and exact Shopify vendor.
  const config = JSON.parse(configElement.textContent);
  const root = config.root.replace(/\/?$/, '/');
  let pending = Promise.resolve(), timer, applying = false;
  const resumed = new WeakSet();
  async function request(path, options = {}) {
    const response = await fetch(root + path, { credentials: 'same-origin', cache: 'no-store',
      ...options, signal: AbortSignal.timeout(8000) });
    if (!response.ok) throw new Error('Shipping offer could not be checked');
    return response.json();
  }
  function show(state, failed) {
    for (const button of document.querySelectorAll('form[action$="/cart"] [name="checkout"]')) {
      const form = button.form;
      let notice = form.querySelector('[data-fww-fluff-shipping]');
      if (!notice) {
        notice = document.createElement('p');
        notice.dataset.fwwFluffShipping = '';
        notice.setAttribute('role', 'status');
        notice.style.cssText = 'margin:12px 0;font-size:14px;line-height:1.4;';
        button.parentElement.insertBefore(notice, button);
      }
      notice.hidden = !state.subtotal;
      notice.dataset.subtotal = String(state.subtotal);
      notice.dataset.eligible = String(state.eligible);
      notice.textContent = failed ? 'Please retry checkout to apply your Fluff & Tuff shipping offer.' :
        state.eligible ? 'Free US shipping unlocked with $50 in Fluff & Tuff. Applied at checkout.' :
        `Add $${Math.max(0, (config.threshold - state.subtotal) / 100).toFixed(2)} in Fluff & Tuff for free US shipping.`;
    }
  }
  async function sync() {
    const cart = await request('cart.js');
    const state = evaluateCart(cart, config);
    if (state.eligible !== state.hasCode) {
      const codes = state.codes.filter(c => c.toUpperCase() !== config.code.toUpperCase());
      if (state.eligible) codes.push(config.code);
      applying = true;
      try {
        await request('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') }) });
      } catch (error) { show(state, true); throw error; }
      finally { applying = false; }
    }
    show(state, false);
    return state;
  }
  function enqueue() {
    pending = pending.catch(() => {}).then(sync);
    return pending;
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(() => { enqueue().catch(error => console.warn('[Fluff shipping]', error.message)); }, 350);
  }
  // DEPENDS: Avenue cart/header use native /cart forms with a named checkout submitter.
  // Resume that same form so cart notes, terms, options and other app listeners survive.
  document.addEventListener('submit', async event => {
    const form = event.target, button = event.submitter;
    if (!(form instanceof HTMLFormElement) || button?.name !== 'checkout' ||
        !new URL(form.action, location.href).pathname.endsWith('/cart')) return;
    if (resumed.has(form)) { resumed.delete(form); return; }
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.fwwShippingBusy) return;
    form.dataset.fwwShippingBusy = 'true';
    button.setAttribute('aria-busy', 'true');
    try {
      clearTimeout(timer);
      await enqueue();
      resumed.add(form);
      form.requestSubmit(button);
    } catch (error) {
      console.warn('[Fluff shipping]', error.message);
      // A transient lookup failure must not silently send an eligible shopper to paid shipping.
      const notice = form.querySelector('[data-fww-fluff-shipping]');
      if (notice) { notice.hidden = false; notice.textContent = 'Please retry checkout; we could not check your shipping offer.'; }
    } finally { delete form.dataset.fwwShippingBusy; button.removeAttribute('aria-busy'); }
  }, true);
  document.addEventListener('click', async event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.button) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    try { await enqueue(); location.assign(url.href); }
    catch (error) { console.warn('[Fluff shipping]', error.message); }
  }, true);
  // Observe completed cart writes without replacing fetch or XMLHttpRequest used by other apps.
  if (typeof PerformanceObserver !== 'undefined') {
    new PerformanceObserver(list => {
      if (!applying && list.getEntries().some(e => /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(e.name))) schedule();
    }).observe({ type: 'resource', buffered: false });
  }
  window.addEventListener('pageshow', schedule);
  document.addEventListener('change', event => { if (event.target.closest('form[action$="/cart"]')) schedule(); });
  schedule();
})();
